import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { FinancingOfferBlock as FinancingOfferBlockValue } from "@reactivated";

import {
    OfferPromo,
    OfferPromoImage,
    OfferPromoSubheader,
    OffersPromoContainer,
} from "../OffersPromo";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: FinancingOfferBlockValue }>;

export const FinancingOfferBlock = (props: IProps): React.JSX.Element => {
    const value = props.value;

    return (
        <OffersPromoContainer title="Everyday Offers" spacing={value.spacing}>
            {(value.offer_panes ?? []).map((pane, index) => (
                <OfferPromo key={index}>
                    <OfferPromoImage
                        src={pane.img?.url ?? ""}
                        alt={t`Cocoon by Sealy Offer`}
                    />
                    <OfferPromoSubheader>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: pane.header ?? "",
                            }}
                        />
                    </OfferPromoSubheader>
                    <div
                        dangerouslySetInnerHTML={{ __html: pane.copy ?? "" }}
                    />
                    <a
                        className={styles.offerPromoLink}
                        href={pane.link?.page?.url ?? ""}
                    >
                        {pane.link?.link_title}
                    </a>
                </OfferPromo>
            ))}
        </OffersPromoContainer>
    );
};
